import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
    this.awsS3Api = options.awsS3Api
  }
  async getTradeHistories (params) {
    const reault = await this.kulapApi.getTradeHistories(params)
    return reault
  }

  async getTradeHistoriesFile (params) {
    const reault = await this.kulapApi.getTradeHistoriesFile(params)
    return reault
  }
}



// WEBPACK FOOTER //
// ./src/pages/TradeHistory/service.js